import React from 'react';
import {
  Box,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import { OptionItem } from './InsightsSearchBar.types';
import { VISIBLE_DROPDOWN_ITEMS } from './constants';

interface FilterOptionsListProps {
  fieldName: string;
  options: OptionItem[];
  isLoading: boolean;
  onOptionSelect: (optionId: string) => void;
}

export const FilterOptionsList = ({
  fieldName,
  options,
  isLoading,
  onOptionSelect,
}: FilterOptionsListProps) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 1,
          py: 0.5,
        }}
      >
        <Typography variant="subtitle2" sx={{ m: 0 }}>
          Select {fieldName} option
        </Typography>
        {isLoading && <CircularProgress size={18} />}
      </Box>
      <Divider sx={{ mb: 0.5 }} />
      <List dense disablePadding>
        {isLoading && options.length === 0 && (
          <ListItem>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CircularProgress size={16} />
              <ListItemText primary="Loading options…" />
            </Box>
          </ListItem>
        )}
        {options.length === 0 && !isLoading && (
          <ListItem>
            <ListItemText primary="No options found" />
          </ListItem>
        )}
        {options.slice(0, VISIBLE_DROPDOWN_ITEMS).map((opt) => (
          <ListItem key={opt.id} disablePadding>
            <ListItemButton disabled={isLoading} onClick={() => onOptionSelect(opt.id)}>
              <ListItemText primary={opt.display} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </>
  );
};
